module.exports = __webpack_public_path__ + "img/TOPAS_img_1.19001212.png";